import { FaChartPie } from 'react-icons/fa';
import { DashboardViewMain } from '../Components/DashboardViewMain';

export const DashboardModule = () => [{
    views: 'PRIVATE', path: '/dashboard', component: <DashboardViewMain />,
    roles: null, permissions: null, label: 'Panel', icon: <FaChartPie />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
